import { AbstractControl, ValidatorFn } from '@angular/forms';

export function domainValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value: string | undefined | null = control.value;

    if (!value) {
      return null;
    }
    const regex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]/;

    if (!regex.test(value)) {
      return { invalidDomain: true };
    }
    return null;
  };
}
